import React, {useEffect, useMemo, useState} from 'react';
import {JobCost} from 'components/customer/Job/store/jobApi';
import {
    Row,
    Item,
    ItemContainer,
    VariationItemContainer,
} from 'components/customer/Confirmation/Checkout/Table';
import {MoreInfoStatic} from 'shared/components/MoreInfo/MoreInfo';
import {VariationCostMoreInfo} from 'shared/components/Header/VariationCostMoreInfo';
import {formatPrice, genericMessageHandler} from 'shared/helpers';
import {useCheckProductVariations} from 'components/customer/Confirmation/helpers/useCheckProductVariations';
import {ProductVariations} from 'components/customer/Confirmation/Checkout/ProductVariations';
import {ExtraVariations} from 'components/customer/Confirmation/Checkout/ExtraVariations';
import {BenchVariations} from 'components/customer/Confirmation/Checkout/BenchVariations';
import styled from 'styled-components';
import {useDeleteAllVariations} from 'components/customer/JobDashboard/helpers/useDeleteAllVariations';
import {useAppSelector} from 'store/customer';
import {
    selectTotalRemovedVariationCost,
    selectTotalRemovedVariationCostGST,
} from 'components/customer/Confirmation/store/confirmationSlice';
import {useNotificationContext} from 'contexts';

export const VariationCost = ({jobCost}: {jobCost?: JobCost | null}) => {
    const {notify} = useNotificationContext();
    const [showVariationTBD, setShowVariationTBD] = useState(false);
    const {checkIfThereAreVariations} = useCheckProductVariations();
    const {deleteAllVariaitons, showDeleteAllButton} = useDeleteAllVariations();

    const totalVariationCostReduction = useAppSelector(
        selectTotalRemovedVariationCost
    );
    const totalVariationGST = useAppSelector(
        selectTotalRemovedVariationCostGST
    );

    const totalVariationCost = useMemo(() => {
        if (jobCost?.totalVariationCost) {
            const variationCost =
                jobCost?.totalVariationCost -
                (totalVariationCostReduction ?? 0) -
                (totalVariationGST ?? 0);

            return formatPrice(variationCost, {}) as string;
        }

        return 'To be Confirmed';
    }, [jobCost, totalVariationCostReduction, totalVariationGST]);

    useEffect(() => {
        checkIfThereAreVariations()
            .then((response) => {
                setShowVariationTBD(response);
            })
            .catch((e) => {
                if (e instanceof Error) {
                    genericMessageHandler(notify, {
                        message: e.message,
                    });
                }
            });
    }, [checkIfThereAreVariations, notify]);

    if (showVariationTBD || jobCost?.totalVariationCost) {
        return (
            <>
                <Row>
                    <td>
                        <ItemContainer>
                            <Item>Variations</Item>

                            {jobCost?.totalVariationCost ? (
                                <MoreInfoStatic
                                    editbuttonVisible={false}
                                    hoverText="Total Variation Costs"
                                    dialogClassName="modal-md"
                                    info={<VariationCostMoreInfo />}
                                />
                            ) : null}
                        </ItemContainer>
                    </td>
                    <td>
                        {jobCost?.totalVariationCost
                            ? null
                            : // ? formatPrice(jobCost?.totalVariationCost, {})
                              'To Be Confirmed'}
                    </td>
                    <td>
                        {showDeleteAllButton ? (
                            <VariationDeleteButton
                                type="button"
                                onClick={deleteAllVariaitons}>
                                Delete all Variations
                            </VariationDeleteButton>
                        ) : null}
                    </td>
                </Row>

                <ProductVariations />

                <BenchVariations />

                <ExtraVariations />

                <Row>
                    <td>
                        <VariationItemContainer>
                            <Item>
                                <strong>Total Variations</strong>
                            </Item>
                        </VariationItemContainer>
                    </td>
                    <td>
                        <strong>{totalVariationCost}</strong>
                    </td>
                    <td />
                </Row>
            </>
        );
    }
};

const VariationDeleteButton = styled.button`
    background: ${({theme}) => theme.colors.primary?.main};
    color: white;
    border: 0;
    border-radius: 8px;
    font-size: 0.85em;
    font-weight: 500;
    transition:
        transform 0.2s ease-out,
        box-shadow 0.2s ease-out;

    &:active {
        transform: scale(0.98);
        box-shadow: 2px 2px 10px rgba(0, 0, 0, 0.3);
    }
`;
